<template>
  <section class="services-area ptb-70">
    <div class="container-fluid p-0">
      <h2>E- Payment gateway</h2>
      <p style="margin-left: 7%;">This offers a host of benefits to merchants and their customers. It enables the merchant to charge purchases to a customer’s credit or debit card while providing a secure and convenient way to make payments. In addition to accepting online payments, the iRechargePay gateway also provides the following:</p>
      <div class="overview-box">
        <div class="overview-content">
          <div class="content left-content">
            <h4>iRechargePayment link</h4>
            
            <p>
              This enables businesses & individuals that do not have websites to receive online payments for goods & services via a URL or QR code. Merchants with a link can share it on their blog or social media accounts; they can also send it to their customers via email, WhatsApp or SMS. 
API Tools, Developer Information and Integration - Connected Merchants have the ability to customize their payment page to suit their needs or brand theme. It also integrates with other tools and Financial applications. 
            </p>
          </div>
        </div>
        <div class="overview-content">
          <div class="content">
          
            <h4>API Tools, Developer Information and Integration </h4>
            
            <p>
             Connected Merchants have the ability to customize their payment page to suit their needs or brand theme. It also integrates with other tools and Financial applications.  
            </p>
          
        </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  
};
</script>

<style scoped>
  
</style>